import { type Region } from '@/navbar/navbar.types'

export const FEATURE_FLAG_DOMAINS: Record<Region | 'test-new-world' | 'staging-new-world', string> = {
  'test-new-world':    'https://features.platform.test.ecoonline.net',
  'staging-new-world': 'https://features.platform.staging.ecoonline.net',
  test:    'https://features.test.ecoonline.cloud',
  staging: 'https://features.test.ecoonline.cloud/stage',
  eu:      'https://features.ecoonline.net',
  uk:      'https://features.platform.uk.ecoonline.com',
  us:      'https://features.platform.us.ecoonline.com',
  ca:      'https://features.platform.ca.ecoonline.com',
  au:      'https://features.platform.au.ecoonline.com',
}
